<div class="sn-search" [class.sn-search--palette]="variant === 'palette'">
  <div class="sn-search__field">
    <i class="fa-solid fa-magnifying-glass sn-search__icon" aria-hidden="true"></i>
    <input #input type="text" class="sn-search__input" autocomplete="off" spellcheck="false"
           role="combobox" aria-autocomplete="list" aria-label="Search the menu"
           [attr.aria-expanded]="!!query.trim()" [attr.aria-controls]="listId"
           [attr.aria-activedescendant]="activeIndex >= 0 && query.trim() ? optionId(activeIndex) : null"
           [attr.aria-keyshortcuts]="isMac ? 'Meta+K' : 'Control+K'"
           placeholder="Search the menu" [value]="query"
           (input)="onInput($any($event.target).value)" (keydown)="onKeydown($event)">
    <kbd *ngIf="!query" class="sn-search__kbd" aria-hidden="true">{{ shortcut }}</kbd>
    <button *ngIf="query" type="button" class="sn-icon-button sn-search__clear" aria-label="Clear search"
            (click)="onInput(''); focus()">
      <i class="fa-solid fa-xmark" aria-hidden="true"></i>
    </button>
  </div>

  <ul *ngIf="query.trim()" class="sn-search__results" role="listbox" [id]="listId" aria-label="Menu search results">
    <li *ngFor="let result of results; let i = index; trackBy: trackByKey" class="sn-search__option" role="option"
        [id]="optionId(i)" [attr.aria-selected]="i === activeIndex" [class.sn-search__option--active]="i === activeIndex"
        (mousedown)="$event.preventDefault()" (mouseenter)="activeIndex = i"
        (click)="open(result.entry, $event.ctrlKey || $event.metaKey)" (auxclick)="open(result.entry, true)">
      <i class="fa-fw sn-search__option-icon" [ngClass]="result.entry.icon || 'fa-solid fa-circle'" aria-hidden="true"></i>
      <span class="sn-search__option-text">
        <span class="sn-search__option-label"><ng-container *ngFor="let segment of segments(result)"><mark *ngIf="segment.match">{{ segment.text }}</mark><ng-container *ngIf="!segment.match">{{ segment.text }}</ng-container></ng-container></span>
        <span *ngIf="result.entry.trail.length" class="sn-search__option-trail">{{ result.entry.trail.join(' › ') }}</span>
      </span>
      <i *ngIf="isStarred(result.entry)" class="fa-solid fa-star sn-search__option-star" aria-label="Favorite"></i>
      <i *ngIf="result.entry.external" class="fa-solid fa-arrow-up-right-from-square sn-search__option-external" aria-hidden="true"></i>
    </li>
    <li *ngIf="!results.length" class="sn-search__empty" role="presentation">No menu items match “{{ query }}”</li>
  </ul>

  <p *ngIf="variant === 'palette'" class="sn-search__hint">
    <kbd>↑</kbd><kbd>↓</kbd> move · <kbd>↵</kbd> open · <kbd>⇧</kbd><kbd>↵</kbd> favorite · <kbd>esc</kbd> close
  </p>
</div>
